(function ($) {
  
  $(document).on('openOnlineStore', function(event){
    console.log('openonlinestore');
  });
  
  var $id = $('#SingleOptionSelector-0').find(":selected").val();
  if (typeof $id != 'undefined') {
    changeDescription($id);
  }
  
  function changeDescription(id){
  	var $default = $('#default-text').html();
    id = id.replace(/\s+/g, '-').toLowerCase();
    var $text = $('#text-' + id).html();
    $('.product-single__description').html($default);
    if ($text != '') {
      $('.product-single__description').html($text);
    }
  }
  
  $("#SingleOptionSelector-0").on('change', function () {
    var $variant = $(this).find(":selected").val();
    changeDescription($variant);
  });
})(jQuery);